import { Button } from "@carbon/react";
import { useGetChannel } from "api/channels/getChannel";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import styles from "./trialBar.module.scss";

export default function TrialBar() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const channel = useSelector((state) => state.selectedChannel);

  const { data: channelDetails = {} } = useGetChannel(channel?.id);

  if (channelDetails?.plan === "trial") {
    const trialRemaining = dayjs(channelDetails.trialEndDate).diff(
      dayjs(),
      "day"
    );

    return (
      <div className={styles.wrapper}>
        <h4>{t("free_trial")}</h4>
        <p className="ml-200 mr-200">
          {trialRemaining > 0
            ? t("x_days_left", {
                count: trialRemaining,
              })
            : t("your_trial_has_expired")}
          {" - "}
          {t("time_to_select_a_plan")}!
        </p>
        <Button
          size="md"
          type="button"
          onClick={() => navigate("/profile/plans")}
        >
          {t("select_a_plan")}
        </Button>
      </div>
    );
  }

  return null;
}
